<osp-toast key="osp-toast" #toast>
  <ng-template let-message>
    <div class="toast" [ngClass]="message.severity === 'neutral' ? 'toast--neutral' : ''">
      @if (message.severity === 'error') {
        <osp-icon [icon]="IconKey.RootToastError | icon" class="toast__icon--error"></osp-icon>
      }
      @if (message.severity === 'success') {
        <osp-icon [icon]="IconKey.RootToastSuccess | icon" class="toast__icon--success"></osp-icon>
      }
      @if (message.severity === 'warn') {
        <osp-icon [icon]="IconKey.RootToastWarn | icon" class="toast__icon--warn"></osp-icon>
      }
      @if (message.severity === 'neutral') {
        <osp-icon [icon]="IconKey.RootToastNeutral | icon" class="toast__icon--neutral"></osp-icon>
      }
      <div class="toast__message-container">
        <p class="text-sm text-color font-semibold toast__summary">{{ message.summary }}</p>
        <p class="text-xs text-color font-semibold toast__detail">{{ message.detail }}</p>
        @if (message.severity === 'error') {
          <p class="text-xs text-color toast__support">{{ 'shared.errorSnackbar.contactSupport' | translate }}</p>
          <p class="text-xs text-color toast__error-time">
            {{ 'shared.errorSnackbar.timeOfFailure' | translate }}:
            {{ message.data.errorTime | formatDateTime: { showTime: true } }}
          </p>
        }
      </div>

      <osp-icon [icon]="IconKey.GlobalClose | icon" (click)="dismiss(message)" class="toast__close-icon" />
    </div>
    @if (message.severity === 'error') {
      <div class="toast__lifebar" [ngClass]="'toast__lifebar--' + message.severity"></div>
    } @else {
      <div
        class="toast__lifebar"
        [ngClass]="'toast__lifebar--' + message.severity"
        @shrinkAnimation
        [ngStyle]="{ transition: 'width ' + (toast.life - 500) + 'ms linear' }"
      ></div>
    }
  </ng-template>
</osp-toast>
